import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { IngresoCredencialesComponent } from './components/ingreso-credenciales/ingreso-credenciales.component';

const routes: Routes = [
  { path: '', redirectTo: '/', pathMatch: 'full' },
  { path: 'formularioClave', component: IngresoCredencialesComponent, data: {title: 'Formulario Credenciales'} },
  { path: '**', redirectTo: '/', pathMatch: 'full' }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
